import React, { Component } from 'react';
import styled from 'styled-components';
import {
  Text,
  Input,
  Column,
  Row,
  Button,
  Label,
  UserWarn,
  StyledSelect,
  LicenceErrorMessage,
} from '../theme/index';
import { getOptions } from '../../fixture/data';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export default class AddLicenseForm extends Component {
  state = {
    second_profession: [],
  };

  render() {
    const {
      handleBlur,
      setFieldValue,
      values,
      touched,
      errors,
      togglemodal,
      handleChange,
    } = this.props;

    const renderLicenseError = (errors = []) => {
      const errorList = errors.map((error, index) => (
        <li key={index}>{error}</li>
      ));
      return (
        <LicenceErrorMessage>
          <span>Please adjust:</span>
          <ul>{errorList}</ul>
        </LicenceErrorMessage>
      );
    };

    return (
      <Wrapper>
        <Column>
          <Text margin=".5em 0 .5em .75em" protitle>
            Add a license number
          </Text>
          <React.Fragment>
            <Column width="75%" margin="0 auto">
              <Row
                margin=".1em 0"
                alignitems="center"
                style={{ position: 'relative' }}
              >
                <Label htmlFor="state">
                  State *
                  {touched.state && errors.state && (
                    <UserWarn>
                      <Text error>{errors.state}</Text>
                    </UserWarn>
                  )}
                  <StyledSelect
                    type="state"
                    form
                    id="state"
                    options={getOptions('state')}
                    onChange={value => {
                      setFieldValue('second_state', value);
                      this.setState({
                        second_profession: getOptions('profession', value),
                      });
                    }}
                    onBlur={handleBlur}
                    value={values.second_state}
                  />
                </Label>
                <Label htmlFor="profession">
                  Profession *
                  {touched.profession && errors.profession && (
                    <UserWarn>
                      <Text error>{errors.profession}</Text>
                    </UserWarn>
                  )}
                  <StyledSelect
                    type="second_profession"
                    form
                    id="second_profession"
                    options={this.state.second_profession}
                    onChange={value => {
                      setFieldValue('second_profession', value);
                    }}
                    onBlur={handleBlur}
                    value={values.second_profession}
                  />
                </Label>
              </Row>
              <Row
                margin=".1em 0"
                alignitems="center"
                style={{ position: 'relative' }}
              >
                <Label htmlFor="second_number">
                  Second #
                  {touched.second_number &&
                    errors.second_number_arr &&
                    errors.second_number_arr.length > 0 &&
                    renderLicenseError(errors.second_number_arr)}
                  <Input
                    type="second_number"
                    id="second_number"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.second_number}
                    bordererror={
                      touched.second_number &&
                      errors.second_number_arr &&
                      errors.second_number_arr.length > 0 &&
                      '1px solid red'
                    }
                    login
                  />
                </Label>
              </Row>
            </Column>
            <Row justifycontent="center">
              <Button add close type="button" onClick={togglemodal}>
                Close
              </Button>
              <Button type="button" onClick={togglemodal} add>
                Save
              </Button>
            </Row>
          </React.Fragment>
        </Column>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/AddLicenseForm.jsx